import { GalleryClient } from "@/components/gallery/GalleryClient";

export default function GalleryPage() {
  return (
    <div className="min-h-screen bg-background">
      <GalleryClient />
    </div>
  );
}
